<template>
	<div class="content">

		<div style="width: 100%;height: 100%">
			<qrcode-stream @decode="onDecode" @detect="onDetect" style="width:100%;height: 100%"></qrcode-stream>
		</div>

	</div>
</template>

<script>
	export default {
		components: {
		},
		created() {
			// this.getSettings();
		},
		data() {
			return {
			}
		},
		methods: {
			onDetect(promise) {
				var self = this;
				promise.then(data => {
					// console.log(data);
				})
				// console.log("hi");
			},
			onDecode(qr) {
				if (String(qr).length == 12 || String(qr).length == 18) {
					this.pickup(String(qr));
				}
				// console.log("hi");
			},
			pickup(hash_id) {
				this.$http.post(this.config.api + "/admin/driver/pick", {
					hash_id: hash_id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អ្នកបានយកកញ្ចប់ឥវ៉ាន់នេះឡើង។",
							icon: 'done',
							type: 'success'
						})
						this.$router.push("/dashboard");
					}
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Scan.vue